/**
 *
 *
 * LeadCounter Component
 *
 */

import React, { useEffect, useState } from "react"
import {
  //   Alert,
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Modal,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
} from "reactstrap"
import PropTypes from "prop-types"
import api from "../../helpers/Api/index"
// import { resolveColumns } from "../../helpers/tools"
//import { isEmpty } from "lodash"
// import { useSelector } from "react-redux"
//import lodash from "lodash"
// import { isEmpty } from "lodash"

const LeadCounter = () => {
  const [showModal, setModal] = useState(false)
  const [record, setRecord] = useState({})
  const [showDropdown, setDropdown] = useState(false)
  const [dropdownRecords, setDropdownRecords] = useState({})
  // const session = useSelector((state) => state && state.session)
  const [counterData, setCounterData] = useState({})
  /// const [leadcounts, setLeadcounts] = useState(false)
  //console.log(leadcounts)
  useEffect(async () => {
    //     if (counterData && Object.keys(counterData).length === 0)
    //       try {
    const data = {
      companyId: [],
      branchId: [],
      mode: "GENERAL",
      employeeId: "",
      processStatus: "",
    }
    return await api
      .post("/get_lead_count_by_status_new", data)
      .then((response) => {
        const dataCount =
          response.data && response.data.data ? response.data.data : ""

        setCounterData(dataCount)
        setDropdownRecords(dataCount)
        response.data && response.data.data
      })
      .catch((error) => Promise.reject(error))
  }, [])

  const leadCounterLabel = [
    {
      customLabel: "Unactioned - Today’s | MTD | Overall",
      label: "Unactioned",
      filterId: "PS2",
      cardStyle: {
        backgroundColor: "#F1B54C",
        marginBottom: "0px",
        display: "inline-block",
        width: "100%",
      },
    },
    {
      customLabel: "Unactioned Follow -ups - Today / MTD",
      label: "Unactioned Follow -ups",
      filterId: "PS16",
      cardStyle: {
        backgroundColor: "#50A5F0",
        marginBottom: "0px",
        display: "inline-block",
        width: "100%",
      },
    },
    {
      customLabel: "Conversions - Today’s | MTD | Overall",
      label: "Conversions",
      filterId: "PS3",
      cardStyle: {
        backgroundColor: "#34C28F",
        marginBottom: "0px",
        display: "inline-block",
        width: "100%",
      },
    },
    {
      customLabel: "Performance - Current RR / Required RR",
      label: "Performance",
      filterId: "PS32",
      cardStyle: {
        backgroundColor: "#353A40",
        marginBottom: "0px",
        display: "inline-block",
        width: "100%",
      },
    },
    {
      customLabel: "Rejected - Today’s | MTD | Overall",
      label: "Rejected",
      filterId: "PS10",
      cardStyle: {
        backgroundColor: "#F46969",
        marginBottom: "0px",
        display: "inline-block",
        width: "100%",
      },
    },
  ]

  //console.log(data, "my data")
  //const leads = counterData.lead.monthLead
  // const leadToday = counterData.lead.todayLead
  // const leadMonth = counterData.lead.monthLead
  // const leadTotal = counterData.lead.totalLead

  // const leadValue = `${leadToday}|${leadMonth}|${le
  // const leadCount = !isEmpty(counterData) ? counterData.map((_) => {
  //   return {
  //     todayLead: _.lead.todayLead,
  //     monthLead: _.lead.monthLead,
  //     totalLead: _.lead.totalLead
  //   }
  // }) : []
  // console.log(leadCount, "leadCount")
  // console.log(leadcounts, "leadcounts")
  return (
    <Container fluid>
      <Row>
        <Col xs={12}>
          <Card>
            <CardBody>
              <Row style={{ alignItems: "center" }}>
                {(leadCounterLabel || [])
                  // .filter((_) => _)
                  .map(
                    (
                      {
                        label,
                        customLabel,
                        cardStyle,

                        filterId,
                        // value,
                        //           colProps = {},
                      },
                      i
                    ) => {
                      // console.log(value, "value mm")
                      // if (value === "lead") {
                      //   setLeadcounts(true)
                      // }
                      // const leads = counterData.lead.mon

                      return (
                        <Col key={i} c>
                          <Card
                            style={cardStyle}
                            className="text-white"
                            onClick={() => {
                              setModal(true)
                              setRecord(
                                Object.assign(
                                  {},
                                  {
                                    label,
                                    filterId,
                                  }
                                )
                              )
                            }}
                          >
                            <CardBody
                              style={{
                                color: "white",
                              }}
                            >
                              {customLabel ==
                              "Unactioned - Today’s | MTD | Overall" ? (
                                <span
                                  style={{
                                    color: "white",
                                    fontWeight: 550,
                                    fontSize: "14px",
                                  }}
                                >
                                  {counterData?.unactioned?.todayLead} |{" "}
                                  {counterData?.unactioned?.monthLead} |{" "}
                                  {counterData?.unactioned?.totalLead}
                                </span>
                              ) : customLabel ==
                                "Unactioned Follow -ups - Today / MTD" ? (
                                <span
                                  style={{
                                    color: "white",
                                    fontWeight: 550,
                                    fontSize: "14px",
                                  }}
                                >
                                  {counterData?.unactioned?.todayLead} |{" "}
                                  {counterData?.unactioned?.monthLead}
                                </span>
                              ) : customLabel ==
                                "Conversions - Today’s | MTD | Overall" ? (
                                <span
                                  style={{
                                    color: "white",
                                    fontWeight: 550,
                                    fontSize: "14px",
                                  }}
                                >
                                  {counterData?.conversion?.todayLead} |{" "}
                                  {counterData?.conversion?.monthLead} |
                                  {counterData?.conversion?.totalLead}
                                </span>
                              ) : customLabel ==
                                "Performance - Current RR / Required RR" ? (
                                <span
                                  style={{
                                    color: "white",
                                    fontWeight: 550,
                                    fontSize: "14px",
                                  }}
                                >
                                  {counterData?.unactioned?.todayLead} |{" "}
                                  {counterData?.unactioned?.monthLead}
                                </span>
                              ) : customLabel ==
                                "Rejected - Today’s | MTD | Overall" ? (
                                <span
                                  style={{
                                    color: "white",
                                    fontWeight: 550,
                                    fontSize: "14px",
                                  }}
                                >
                                  {counterData?.rejected?.todayLead} |{" "}
                                  {counterData?.rejected?.monthLead} |{" "}
                                  {counterData?.rejected?.totalLead}
                                </span>
                              ) : (
                                ""
                              )}

                              <h6
                                style={{
                                  color: "white",
                                }}
                              >
                                {customLabel}
                              </h6>
                            </CardBody>
                            {/* {(counterData &&
                                 Object.keys(counterData) &&
                                 counterData[value].lead.todayLead) ||
                                 "9"} */}

                            {/* {(counterData &&
                                 Object.keys(counterData) &&
                                 JSON.stringify(counterData[value])) ||
                                 "0"} */}
                            {/* {leadCount.todayLead + "|" + leadCount.monthLead + "|" + leadCount.totalLead} */}
                            {/* {counterData.conversion.todayLead + "|" + counterData.conversion.monthLead + "|" + counterData.conversion.totalLead} */}

                            {/* {(counterData 
                                 &&counterData .map((k)=>{k.monthLead})) ||
                                 "0"} */}

                            {/* {(value && value.monthLead && counterData &&
                                Object.keys(counterData[value].monthLead))||
                                 "0|17|20"} */}

                            {/* {(counterData &&
                                   Object.keys(counterData).length > 0 &&
                                   Object.keys(counterData)
                                     .map((k) => counterData[k.todayLead])
                                     .join(" | ")) ||
                                   "00 | 00 | 00"}  */}
                          </Card>
                        </Col>
                      )
                    }
                  )}
              </Row>
            </CardBody>
          </Card>
        </Col>
        <Modal
          size="xl"
          isOpen={showModal}
          style={{ height: "300px", background: "white" }}
        >
          <div
            className="modal-header"
            style={{
              background: "#E40D8C",
              color: "white",
              borderRadius: "0px",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div style={{ fontSize: "16px" }}>
              {record && record.label} - {"Today's Lead"} :{" "}
              {record && record.todayLead} | MTD:{" "}
              {record && record.monthTillDate} | Over All Leads:{" "}
              {record && record.totalLead}
            </div>
            <div onClick={() => setModal(false)} style={{ cursor: "pointer" }}>
              <i
                style={{ fontSize: "18px", fontWeight: "bold" }}
                className="mdi mdi-close"
              ></i>
            </div>
          </div>
          <div className="modal-body">
            {dropdownRecords && Object.keys(dropdownRecords).length > 0 ? (
              Object.keys(dropdownRecords).map((k, i) => {
                const dropdownRecord =
                  (record &&
                    record.filterId &&
                    dropdownRecords[k] &&
                    dropdownRecords[k].length > 0 &&
                    dropdownRecords[k].filter(
                      (_) =>
                        _.processStatus.toString() ===
                        record.filterId.toString()
                    )) ||
                  (dropdownRecords[k] &&
                    dropdownRecords[k].length > 0 &&
                    dropdownRecords[k]) ||
                  []
                const overallCountObj = dropdownRecord.reduce(
                  (a, el) =>
                    Object.assign({}, a, {
                      monthTillDate:
                        parseInt(a.monthTillDate) + parseInt(el.monthTillDate),
                      todayLead: parseInt(a.todayLead) + parseInt(el.todayLead),
                      totalLead: parseInt(a.totalLead) + parseInt(el.totalLead),
                    }),
                  { todayLead: 0, monthTillDate: 0, totalLead: 0 }
                )
                return dropdownRecord && dropdownRecord.length > 0 ? (
                  <ButtonDropdown
                    key={i}
                    className="count-dropdown"
                    isOpen={showDropdown === k}
                    toggle={() =>
                      showDropdown ? setDropdown(false) : setDropdown(k)
                    }
                  >
                    <DropdownToggle caret color="secondary">
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <p>
                            {(dropdownRecord &&
                              dropdownRecord.length > 0 &&
                              dropdownRecord[0] &&
                              dropdownRecord[0].company_name) ||
                              ""}
                          </p>
                          <div
                            style={{
                              color: "rgb(228, 13, 140)",
                              fontSize: "18px",
                            }}
                            dangerouslySetInnerHTML={{
                              __html: `<b>${
                                (overallCountObj &&
                                  Object.keys(overallCountObj).length > 0 &&
                                  Object.keys(overallCountObj)
                                    .map((k) => overallCountObj[k])
                                    .join(
                                      " &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp; "
                                    )) ||
                                "00 &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp; 00 &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp; 00"
                              }</b>`,
                            }}
                          ></div>
                        </div>
                        <i className="mdi mdi-chevron-down"></i>
                      </div>
                    </DropdownToggle>
                    <DropdownMenu style={{ width: "100%" }}>
                      {(dropdownRecord || []).map(
                        (
                          { branch_name, todayLead, monthTillDate, totalLead },
                          j
                        ) => {
                          return (
                            <div
                              key={j}
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between",
                                paddingRight: "15px",
                                paddingLeft: "15px",
                              }}
                            >
                              <p>{branch_name || "--"}</p>
                              <div
                                style={{
                                  color: "rgb(228, 13, 140)",
                                  fontSize: "15px",
                                }}
                              >
                                {todayLead || "0"} &nbsp;&nbsp;|&nbsp;&nbsp;{" "}
                                {monthTillDate || "0"} &nbsp;&nbsp;|&nbsp;&nbsp;{" "}
                                {totalLead || "0"}
                              </div>
                            </div>
                          )
                        }
                      )}
                    </DropdownMenu>
                  </ButtonDropdown>
                ) : null
              })
            ) : (
              <div>No Record Found.</div>
            )}
          </div>
        </Modal>
      </Row>
    </Container>
  )
}

LeadCounter.propTypes = {
  columns: PropTypes.func,
  onLoad: PropTypes.func,
  metaData: PropTypes.any,
  className: PropTypes.any,
  name: PropTypes.any,
}

export default LeadCounter
